'use strict';

var _ = require('lodash');
var angular = require('angular');
var GridPanelController = function GridPanelController($scope, $rootScope, $log, $q, $timeout, GridSettingsService, printService, JQXGridSettingsFactory, GridSettingsMergeService, ConfigurationLoaderService, SortCriteria, JQXGridDataAdapterFactory, JQXGridCustomSortService, JQXGridCellTreatmentService, calculatedColumnService, dataRetrieverService, dataRetrieverConstantsService, dataService, GridColumnFactory, BenchmarkService, momentService, gridTooltipService, userPreferencesService, columnNameTransformationService, gridColumnConditionallyEditableService, liveDataService, userActionService, GridDynamicConfigDrivenColumnStrategiesService) {
  function tooltipHandler(cellElement, pageX, pageY, cellData) {
    if (_.has($scope.jqxGridSettings, ['source', 'loadedData'])) {
      var dataBeforeRefresh = _.get($scope.jqxGridSettings, 'source._source.$dataBeforeRefresh'),
        refreshCellNames = JQXGridCellTreatmentService.getRefreshCellNames();
      gridTooltipService.tooltipTrigger(cellElement, pageX, pageY, cellData, $scope.jqxGridSettings.source.loadedData, $scope.gridId, dataBeforeRefresh, refreshCellNames);
    }
  }
  var CELL_FILL_DOWN_KEY = 'D';
  var deferredLoadOnVisible = false;
  $scope.gridDataLoaded = false;
  $scope.gridDataUpdated = false;
  $scope.dynamicColumnsView = 'default';
  if ($scope.dynamicGridSettings) {
    $scope.gridSettings = $scope.dynamicGridSettings;
    $scope.applicationDefaultData = $scope.dynamicGridSettings;
    $scope.dataFields = $scope.dynamicGridSettings.dynamicFields;
  } else {
    $scope.gridSettings = GridSettingsService.getDefaultGridSettings($scope.gridId, $scope.mode);
    $scope.applicationDefaultData = GridSettingsService.getDefaultGridSettings($scope.gridId, $scope.mode);
    $scope.dataFields = ConfigurationLoaderService.getGridDataFields($scope.gridId).fields;
  }
  $scope.customRenderers = $scope.customRenderers || {};
  $scope.showSelectionCheckboxes = !angular.isDefined($scope.showSelectionCheckboxes) ? $scope.gridSettings.editable : $scope.showSelectionCheckboxes;
  $scope.jqxGridSettings = JQXGridSettingsFactory.getJQXGridSettings($scope.gridSettings, $scope.dataFields, $scope.customRenderers, $scope.showSelectionCheckboxes, {
    handler: tooltipHandler
  });
  $scope.momentService = momentService;
  $scope.filteringDisabled = true;
  $scope.cellEndEditData = [];
  $scope.gridHeight = 0;
  $scope.gridReadyPromise = $q.defer();
  $scope.gridVisiblePromise = $q.defer();
  $scope.loadingCaption = $scope.loadingCaption || 'Loading...';
  $scope.keepGridFilteringState = $scope.keepGridFilteringState || false;
  $scope.gridLastState = null;
  $scope.lastRefreshed = momentService.now(momentService.FIELD.EVENT_TIME_STAMP);
  $scope.isLiveData = !_.isUndefined($scope.isLiveData) ? $scope.isLiveData : false;
  $scope.isToolbarVisible = !_.isUndefined($scope.isToolbarVisible) ? $scope.isToolbarVisible : true;
  $scope.retrieveDataOnInit = _.isUndefined($scope.retrieveDataOnInit) || !!$scope.retrieveDataOnInit;
  $scope.retrieveDataOnSearch = _.isUndefined($scope.retrieveDataOnSearch) || !!$scope.retrieveDataOnSearch;
  $scope.isServerSortingEnabled = $scope.serverSorting !== 'false';
  if (!$scope.isServerSortingEnabled) {
    dataRetrieverService.getDataRetriever($scope.screen, $scope.mode).defaultSortDefer.resolve({});
  }
  $scope.undoVisible = {
    show: false
  };
  $scope.keyboardNavigationHandler = function (event) {
    var key = event.charCode ? event.charCode : event.keyCode ? event.keyCode : 0;
    var keyChar = String.fromCharCode(key);
    if (keyChar === CELL_FILL_DOWN_KEY && event.ctrlKey) {
      $scope.fillDownCells();
      return true;
    }
  };

  /**
   * Checks if more than two cells and just one column are selected, and if this column is editable
   *
   * @param {Array} selectedCells
   * @param {Array} dataFields
   * @returns {boolean}
   */
  function shouldStopCellFillDown(selectedCells, dataFields) {
    if (selectedCells.length < 2) {
      return true;
    }
    for (var i = 0; i < dataFields.length; i++) {
      var columnSettings = $scope.getColumnSettings(dataFields[i]);
      // even if at least one column is editable, we should allow to cell fill down
      if (columnSettings.editable && !columnSettings.fillDownDisabled) {
        return false;
      }
    }
    return true;
  }
  var updateBoundDataStrategy = {
    update: function update(rowIndex, dataField, value) {
      $scope.jqxGridSettings.source.loadedData[rowIndex][dataField] = value;
    },
    after: function after() {
      var scrollPos = syncGridCall('scrollposition');
      $scope.jqxGridSettings.jqxGrid('updatebounddata', 'cells');
      $scope.restoreScrollPosition(scrollPos);
    }
  };
  $scope.getColumnSettings = function (dataFieldName) {
    return _.find($scope.jqxGridSettings.columns, {
      datafield: dataFieldName
    });
  };
  $scope.$on('grid:fillBulkOverrides', function (event, gridId, data) {
    if ($scope.gridId === gridId) {
      $scope.fillBulkOverrides(data);
      $scope.updateDataRowPostEdit();
    }
  });
  $scope.triggerSaveNotificationModal = function (datafield, rowUpdateData) {
    $rootScope.$broadcast('grid:cellValueChanged', {
      datafield: datafield,
      newvalue: rowUpdateData.newValue,
      oldvalue: rowUpdateData.oldValue,
      rowindex: rowUpdateData.rowIndex,
      value: rowUpdateData.newValue
    }, $scope.gridId);
  };
  $scope.updateRowWithStrategy = function (strategy, dataField, rowUpdateData) {
    var rowIndex = rowUpdateData.rowIndex;
    var newValue = rowUpdateData.newValue;
    var oldValue = rowUpdateData.oldValue;
    if (isCellEditable(rowIndex, dataField, newValue)) {
      strategy.update(rowIndex, dataField, newValue);
      markCellAsEdited(rowIndex, dataField, oldValue, newValue);
      initCellEndEditData(rowIndex, dataField, newValue, true);
      $scope.triggerSaveNotificationModal(dataField, rowUpdateData);
    }
  };
  $scope.fillBulkOverrides = function (bulkOverrideData) {
    var rows = $scope.jqxGridSettings.jqxGrid('getrows');
    var loadedData = $scope.jqxGridSettings.source.loadedData;
    _.forEach(bulkOverrideData, function (overrideData) {
      var dataField = overrideData.field;
      var rowsToUpdate = _.transform(rows, function (result, row) {
        var rowId = row[overrideData.matchingField];
        var rowIndex = row.uid;
        if (overrideData.userValues[rowId] !== undefined && isCellEditable(rowIndex, dataField, overrideData.userValues[rowId])) {
          var newValue = overrideData.userValues[rowId];
          var oldValue = loadedData[rowIndex][dataField];
          if (newValue !== oldValue) {
            result.push({
              rowIndex: rowIndex,
              newValue: overrideData.userValues[rowId],
              oldValue: loadedData[rowIndex][dataField]
            });
          }
        }
        return result;
      }, []);
      if (rowsToUpdate.length) {
        $scope.undoVisible.show = true;
      }
      _.forEach(rowsToUpdate, function (rowToUpdate) {
        $scope.updateRowWithStrategy(updateBoundDataStrategy, dataField, rowToUpdate);
      });
    });
  };
  $scope.updateDataRowPostEdit = function () {
    var loadedData = $scope.jqxGridSettings.source.loadedData;
    updateDataRowAfterCellEndEdit(loadedData, true);
    updateBoundDataStrategy.after();
  };
  $scope.prepareAndFillDownOverrides = function (selectedCells) {
    var rows = $scope.jqxGridSettings.jqxGrid('getrows');
    var dataFields = _.chain(selectedCells).map('datafield').uniq().value();
    if (shouldStopCellFillDown(selectedCells, dataFields)) {
      return false;
    }
    _.forEach(dataFields, function (dataField) {
      var rowIndexes = _.map(selectedCells, 'rowindex');
      rowIndexes = _.uniqBy(rowIndexes, Math.abs);
      var value = getOverriddenValue(rows, rowIndexes, dataField);
      $scope.fillBulkOverrides(prepareCellFillColumnArray(rowIndexes, dataField, value));
    });
    $scope.updateDataRowPostEdit();
  };
  function prepareCellFillColumnArray(rowIndexes, dataField, value) {
    return [{
      matchingField: 'uid',
      field: dataField,
      userValues: _.transform(rowIndexes, function (result, rowIndex) {
        result[rowIndex] = value;
        return result;
      }, {})
    }];
  }
  function getOverriddenValue(rows, rowIndexes, dataField) {
    var firstRowIndex = _.head(rowIndexes);
    var firstRow = _.get(rows, firstRowIndex);
    var value = firstRow && firstRow[dataField];
    var isFiltered = !firstRow || !_.isNil(firstRow.dataindex);
    if (isFiltered) {
      var loadedData = $scope.jqxGridSettings.source.loadedData;
      value = loadedData[firstRowIndex][dataField];
    }
    return value;
  }
  $scope.fillDownCells = function () {
    $scope.asyncGridApply('getselectedcells').then(function (selectedCells) {
      $scope.prepareAndFillDownOverrides(selectedCells);
    });
  };
  function isCellEditable(rowIndex, dataField, value) {
    var columnConfiguration = _.find($scope.jqxGridSettings.columns, {
      id: $scope.gridId + '-' + dataField
    });
    var editableCondition = columnConfiguration.editableCondition;
    if (!editableCondition) {
      return !!columnConfiguration.editable;
    }
    var params = [$scope.jqxGridSettings.source.loadedData, rowIndex, dataField, value, columnConfiguration.editableDependency];
    return gridColumnConditionallyEditableService.areEditableConditionsMet(editableCondition, params);
  }
  function addDataDrivenColumns(data) {
    var dataDefined = data !== undefined && data.length !== 0;
    $scope.gridSettings.columns.forEach(function (group) {
      if (dataDefined && group.visible && group.dataDrivenColumn) {
        var firstRow = data[0];
        var templateSettings = group.dataDrivenColumn;
        var fieldPrefix = templateSettings.field;
        var isDynamicColumn = function isDynamicColumn(name) {
          return name.slice(0, fieldPrefix.length) === fieldPrefix;
        };
        var extractTitle = function extractTitle(dataField) {
          return dataField.substring(fieldPrefix.length);
        };
        var newColumns = _.chain(firstRow).keys().filter(isDynamicColumn).value();
        var columnConfigUnchanged = false;
        if ($scope.dynamicColumnSorter) {
          var oldTitles = _.map(group.columns, 'title');
          var newTitles = $scope.dynamicColumnSorter(_.map(newColumns, extractTitle));
          columnConfigUnchanged = _.isEqual(newTitles, oldTitles);
        } else {
          var oldFields = _.map(group.columns, 'field');
          columnConfigUnchanged = _.isEqual(newColumns.sort(), oldFields.sort());
        }
        if (!columnConfigUnchanged) {
          if (group.columns.length) {
            _.remove($scope.dataFields, function (dataField) {
              return dataField.name.slice(0, fieldPrefix.length) === fieldPrefix;
            });
            group.columns = [];
          }
          newColumns.forEach(function (newFieldName) {
            $scope.dataFields.push({
              name: newFieldName,
              type: templateSettings.dataFieldType || 'number'
            });
            group.columns.push(new GridColumnFactory({
              gridId: $scope.gridId,
              field: newFieldName,
              title: getDynamicColumnTitle(newFieldName.substring(fieldPrefix.length)),
              groupId: group.groupId,
              visible: true,
              width: templateSettings.width,
              format: templateSettings.format,
              tooltip: templateSettings.tooltip,
              renderer: templateSettings.renderer
            }));
          });
          if ($scope.dynamicColumnSorter) {
            group.columns = $scope.dynamicColumnSorter(group.columns);
          }
          syncJQXGridSettings();
        }
      }
    });
  }
  function getDynamicColumnTitle(columnTitle) {
    if ($scope.dynamicColumnTitleFormatter) {
      return $scope.dynamicColumnTitleFormatter(columnTitle);
    }
    if (columnTitle.match(/^\d+$/)) {
      return +columnTitle;
    }
    return columnTitle;
  }
  $scope.asyncGridApply = function () {
    var args = Array.prototype.slice.call(arguments);
    $scope.gridVisiblePromise = $scope.gridVisiblePromise || $q.defer();
    $scope.gridReadyPromise = $scope.gridReadyPromise || $q.defer();
    return $q.all([$scope.gridReadyPromise.promise, $scope.gridVisiblePromise.promise]).then(function () {
      var execute = $q.defer();
      $timeout(function () {
        execute.resolve();
      }, 0);
      return execute.promise.then(function () {
        return $scope.jqxGridSettings.apply.apply($scope.jqxGridSettings, args);
      });
    });
  };
  $scope.syncGridApply = syncGridCall;
  function syncGridCall() {
    var args = Array.prototype.slice.call(arguments);
    return $scope.jqxGridSettings.jqxGrid.apply($scope.jqxGridSettings, args);
  }

  // added to enable more accurate grid testing (will never be true for the production env.)
  function prepareColumnsToBeVisibleInTests(userGridSettings) {
    if (_.isArray(userGridSettings.visibleColumns)) {
      var visibleColumns = [];
      _.forEach($scope.gridSettings.columns, function (c) {
        if (_.isUndefined(c.columns) && userGridSettings.visibleColumns.indexOf(c.field) !== -1) {
          visibleColumns.push(c);
        } else if (!_.isUndefined(c.columns)) {
          _.forEach(c.columns, function (gc) {
            if (userGridSettings.visibleColumns.indexOf(c.groupId + '.' + gc.field) !== -1) {
              visibleColumns.push(gc);
            }
          });
        }
      });
      $scope.gridSettings.columns = visibleColumns;
    }
  }
  function updateGridSettings(userGridSettings, dynamicColumnView, customDefault) {
    if (!_.isEmpty(userGridSettings)) {
      if (dynamicColumnView && dynamicColumnView !== 'default') {
        userGridSettings.gridId = _.first(userGridSettings.gridId.split(':'));
      }
      $scope.gridSettings = GridSettingsMergeService.mergeGridSettings(customDefault || $scope.applicationDefaultData, userGridSettings);
      if (userPreferencesService.getUserSettingComponent('hideMappedCols') === true) {
        hideMappedColumns();
      }
      prepareColumnsToBeVisibleInTests(userGridSettings);
      syncJQXGridSettings();
      $scope.$broadcast('grid:gridColumnsUpdated');
    } else {
      JQXGridCustomSortService.setDefaultSortCriteria($scope.gridId, $scope.getDefaultSortCriteria());
    }
    var sortCriteria = $scope.gridSettings.sortCriteria || $scope.getDefaultSortCriteria();
    applyGridSorting(sortCriteria);
  }
  function hideMappedColumns() {
    var toggleMappedVisible = function toggleMappedVisible(column) {
      return column.field.indexOf('Mapped') === -1 && column.field.indexOf('mapped') === -1;
    };
    $scope.gridSettings.columns = _.map($scope.gridSettings.columns, function (column) {
      if (column.columns) {
        column.columns = _.map(column.columns, function (column) {
          column.visible = toggleMappedVisible(column);
          return column;
        });
      } else {
        column.visible = toggleMappedVisible(column);
      }
      return column;
    });
  }
  function collectDataBeforeRefresh() {
    if ($scope.isLiveData && $scope.isManualRefreshInProgress) {
      var previousData = _.get($scope.jqxGridSettings, 'source.loadedData');
      return _.chain(previousData).filter('entryKey').keyBy('entryKey').value();
    }
  }
  function updateData(data) {
    $scope.gridDataLoaded = false;
    var timingId = BenchmarkService.start('grid-load-' + $scope.gridId);
    calculatedColumnService.calculateAndAddColumnsToModel($scope.gridSettings.columns, $scope.dataFields, data);
    updateDataRowAfterCellEndEdit(data);
    addDataDrivenColumns(data);
    if ($scope.dynamicColumnsView && $scope.dynamicColumnsView !== 'default') {
      addDynamicConfigColumns($scope.dynamicColumnsView);
    }
    var dataBeforeRefresh = collectDataBeforeRefresh();
    var jqxDataAdapter = JQXGridDataAdapterFactory.getGridDataAdapter($scope.gridSettings, data, dataBeforeRefresh);
    return $scope.asyncGridApply().then(function () {
      $scope.jqxGridSettings.source = jqxDataAdapter;
      if ($scope.reoptPreviewData) {
        $scope.reoptPreviewData.gridDetails = $scope.reoptPreviewData.gridDetails || {};
        $scope.reoptPreviewData.gridDetails[$scope.gridId] = $scope.jqxGridSettings;
      }
    }).then(function () {
      return applyDataAdapter(data, timingId);
    }).then(function () {
      $scope.$broadcast('re-opt:reset:' + $scope.gridId);
      checkForNotifications(data);
      return data;
    });
  }

  /**
   * Updates data in row after cell was edited
   *
   * If loadedDataChanged could have three states:
   *  - undefined - default value, used when editing one cell (Effective value, calculated columns etc.)
   *  - true/false - used when useUpdateBoundData is true/false in $scope.fillDownCells.
   *      If true do not use setcellvalue, calculateColumnsOnCellEdit does that (it's changing loaded data).
   *
   *
   * @param {Array} data
   * @param {(Boolean|undefined)} loadedDataChanged
   */
  function updateDataRowAfterCellEndEdit(data, loadedDataChanged) {
    if (_.isEmpty($scope.cellEndEditData)) {
      return;
    }
    var changedData = calculateColumnsOnCellEdit(data);
    if (!loadedDataChanged) {
      var jqxGridApi = _.isUndefined(loadedDataChanged) ? $scope.asyncGridApply : $scope.jqxGridSettings.jqxGrid;
      _.forEach(changedData.changedColumnNames, function (columnName) {
        _.forEach(changedData.affectedRowIds, function (rowId) {
          if (data[rowId]) {
            jqxGridApi('setcellvalue', rowId, columnName, data[rowId][columnName]);
          }
        });
      });
    }
  }
  function calculateColumnsOnCellEdit(data) {
    if (!_.isEmpty($scope.cellEndEditData)) {
      var changedColumnNames = [];
      var affectedRowIds = [];
      var columnsDependencyModel = calculatedColumnService.prepareCellEditColumnsDependencyModel($scope.gridSettings.columns);
      _.forEach($scope.cellEndEditData, function (cellEditData) {
        var rowId = cellEditData.rowId;
        var columnDataField = cellEditData.columnDataField;
        var changedValue = cellEditData.changedValue;
        changeEditedCellAndAllDependentColumns(rowId, columnDataField, changedValue, data, columnsDependencyModel, changedColumnNames, affectedRowIds);
      });
      $scope.cellEndEditData = [];
      return {
        affectedRowIds: _.uniq(affectedRowIds),
        changedColumnNames: _.uniq(changedColumnNames)
      };
    }
  }
  function changeEditedCellAndAllDependentColumns(rowId, columnDataField, changedValue, data, dependencyModel, changedColumnNames, affectedRowIds) {
    affectedRowIds.push(rowId);
    changedColumnNames.push(columnDataField);
    var rowData = data[rowId];
    rowData[columnDataField] = changedValue;
    if (_.isFunction($scope.cellEditHandler)) {
      var editDataPointer = $scope.cellEditHandler(data, rowId, columnDataField);
      if (editDataPointer) {
        affectedRowIds.push.apply(affectedRowIds, editDataPointer.ids);
        changedColumnNames.push.apply(changedColumnNames, editDataPointer.fieldNames);
        for (var i = 0; i < editDataPointer.fieldNames.length; i++) {
          var fieldName = editDataPointer.fieldNames[i];
          for (var s = 0; s < editDataPointer.ids.length; s++) {
            var id = editDataPointer.ids[s];
            calculatedColumnService.changeAllDependentData(data[id], dependencyModel, fieldName, changedColumnNames);
          }
        }
      }
    }
    calculatedColumnService.changeAllDependentData(rowData, dependencyModel, columnDataField, changedColumnNames);
  }
  function applyDataAdapter(data, timingId) {
    $scope.$broadcast('grid:beforeUpdateBoundData');
    $scope.$emit('grid:beforeUpdateBoundData', data);
    storeLastGridState();
    var currentScrollPosition = syncGridCall('scrollposition');
    return $scope.asyncGridApply('clearselection').then(function () {
      var lastSortApplied = $scope.lastSortCriteriaApplied;
      if (lastSortApplied && !$scope.isDefaultSort(lastSortApplied)) {
        $scope.sortBy(lastSortApplied, lastSortApplied.isCustomSort());
      } else if (!$scope.isServerSortingEnabled) {
        $scope.sortBy(lastSortApplied || $scope.getDefaultSortCriteria());
      }
      return $scope.asyncGridApply().then(function () {
        $scope.gridDataLoaded = true;
        $scope.isManualRefreshInProgress = false;
        $scope.$emit('grid:afterUpdateBoundData', data, $scope.gridId);
        applyLastGridState();
        $scope.restoreScrollPosition(currentScrollPosition);
        BenchmarkService.end(timingId);
      });
    });
  }
  function markCellAsEdited(rowIndex, dataField, oldValue, newValue) {
    var rowData = $scope.jqxGridSettings.source.loadedData[rowIndex];
    var original = _.get(rowData, ['_original', dataField]);
    /*
     Let standardize variables in order to use complex comparation, we can treat undefined and null as empty string
     safely in order to preserve simplicity
     */

    var originalStandardized = _.isNil(original) ? '' : original;
    oldValue = _.isNil(oldValue) ? '' : oldValue;
    newValue = _.isNil(newValue) ? '' : newValue;

    /*
    We should not allow to edit if values does not change over time and is back to original, as new keyboard navigation are now turned on
    in all the grids every time that is enter to edit mode even if the value is same is still mark row as edited.
    Must not be that case.
     */
    var skipEdit = _.isEqual(oldValue, newValue) || !_.isUndefined(original) && _.isEqual(originalStandardized, newValue);
    if (skipEdit) {
      return;
    }
    if (!rowData._old) {
      // create structure for old data if needed
      rowData._old = {};
    }
    if (!rowData._original) {
      // create structure for original data if needed
      rowData._original = {};
    }
    if (!rowData._old.hasOwnProperty(dataField)) {
      // set old value only if the old value wasn't defined before
      var fieldSettings = getFieldSettings(dataField);
      var isPercent = oldValue !== undefined && fieldSettings && fieldSettings.percentageFormat;
      var oldValueToStore = isPercent ? oldValue / 100 : oldValue;
      rowData._original[dataField] = rowData[dataField];
      rowData._old[dataField] = oldValueToStore;
    } else if ((_.isNil(newValue) || newValue === '') && _.isNil(rowData._original[dataField])) {
      // we want to remove _.old attribute, when new value is empty and original was empty too
      delete rowData._old[dataField];
      return;
    }
    rowData.originalRowId = rowIndex;
  }
  $scope.clearModifiedCells = function (event, gridId) {
    if (!gridId || gridId === $scope.gridId) {
      $scope.undoVisible.show = false;
      if ($scope.jqxGridSettings.source) {
        _.map($scope.jqxGridSettings.source.loadedData, function (row) {
          delete row._old;
        });
        $scope.jqxGridSettings.jqxGrid('refresh');
      }
    }
  };
  function updateAllCalculatedColumns(updatedRows) {
    var dependencyModel = calculatedColumnService.prepareCellEditColumnsDependencyModel($scope.gridSettings.columns);
    var columnsToRecalculate = _.map(dependencyModel, 'columnField');
    _.forEach(updatedRows, function (updatedRow) {
      _.forEach(columnsToRecalculate, function (colName) {
        calculatedColumnService.changeAllDependentData(updatedRow, dependencyModel, colName);
      });
    });
  }
  $scope.$on('grid:loadedDataChanged:' + $scope.gridId, function (evt, updatedRows) {
    var loadedData = $scope.jqxGridSettings.source.loadedData;
    var currentScrollPosition = syncGridCall('scrollposition');
    updateAllCalculatedColumns(updatedRows);
    updateDataRowAfterCellEndEdit(loadedData, true);
    $scope.jqxGridSettings.jqxGrid('updatebounddata', 'data');
    $scope.restoreScrollPosition(currentScrollPosition);
  });
  function addDynamicConfigColumns(dynamicGroupName) {
    var isDefault = dynamicGroupName === 'default';
    var dynamicColumns = _.filter($scope.gridSettings.dynamicColumns, {
      dynamicGroupName: dynamicGroupName
    });
    var gridColumns = $scope.gridSettings.columns;
    if (_.isEmpty(dynamicColumns) && !isDefault) {
      $scope.dynamicColumnsView = 'default';
      return;
    }
    $scope.dynamicColumnsView = dynamicGroupName;
    _.remove(gridColumns, function (column) {
      return !!column.dynamicGroupName;
    });
    $rootScope.$broadcast('loading:progress', true);
    return GridDynamicConfigDrivenColumnStrategiesService.transform(dynamicColumns, $scope.dataFields).then(function (dynamicColumns) {
      if (!isDefault) {
        var afterIndex = _.findIndex(gridColumns, {
          field: dynamicColumns[0].afterColumnPosition
        });
        afterIndex = !!~afterIndex ? afterIndex + 1 : gridColumns.length;
        gridColumns.splice.apply(gridColumns, [afterIndex, 0].concat(dynamicColumns));
      }
      var jqxColumnGroups = JQXGridSettingsFactory.convertToJQXColumnGroups(gridColumns);
      var jqxColumns = JQXGridSettingsFactory.convertToJQXColumns(gridColumns, $scope.dataFields, null, $scope.customRenderers);
      JQXGridSettingsFactory.updateJQXColumnFormulas(jqxColumns);
      $scope.jqxGridSettings.columngroups = jqxColumnGroups;
      $scope.jqxGridSettings.columns = jqxColumns;
      $scope.syncGridApply('columngroups', jqxColumnGroups);
      $scope.syncGridApply('columns', jqxColumns);
      $rootScope.$broadcast('loading:finish', true);
    });
  }
  $scope.$on('grid:changecolumns:' + $scope.gridId, function (ev, dynamicGroupName) {
    GridSettingsService.retrieveGridSettings($scope.gridId, dynamicGroupName).then(_.partialRight(updateGridSettings, dynamicGroupName, GridSettingsService.getDefaultGridSettings($scope.gridId)))["finally"](function () {
      addDataDrivenColumns(_.get($scope, 'jqxGridSettings.source.loadedData'));
      return addDynamicConfigColumns(dynamicGroupName);
    });
  });
  $scope.$on('scenarios:saved', $scope.clearModifiedCells);
  $scope.$on('overrides:clear-cells', $scope.clearModifiedCells);
  function syncJQXGridSettings() {
    var jqxColumnGroups = JQXGridSettingsFactory.convertToJQXColumnGroups($scope.gridSettings.columns);
    var jqxColumns = JQXGridSettingsFactory.convertToJQXColumns($scope.gridSettings.columns, $scope.dataFields, null, $scope.customRenderers);
    JQXGridSettingsFactory.updateJQXColumnFormulas(jqxColumns);
    JQXGridCustomSortService.setDefaultSortCriteria($scope.gridId, $scope.getDefaultSortCriteria());
    $scope.asyncGridApply().then(function () {
      $scope.jqxGridSettings.columngroups = jqxColumnGroups;
      $scope.jqxGridSettings.columns = jqxColumns;
    });
    $scope.asyncGridApply('columngroups', jqxColumnGroups);
    $scope.asyncGridApply('columns', jqxColumns);
    $scope.sortBy($scope.getDefaultSortCriteria());
  }
  function prepareForSaving(gridSettings, saveSortCriteria) {
    var toSave = angular.copy(gridSettings);
    toSave.columns = _.transform(toSave.columns, function (result, column) {
      return result.push(column.toExportFormat());
    });
    toSave = toSave.toExportFormat();
    if (saveSortCriteria) {
      toSave.sortCriteria = toSave.sortCriteria.toExportFormat();
    } else {
      toSave.sortCriteria = $scope.getDefaultSortCriteria().toExportFormat();
    }
    if ($scope.dynamicColumnsView && $scope.dynamicColumnsView !== 'default') {
      toSave.gridId = [toSave.gridId, $scope.dynamicColumnsView].join(':');
    }
    if ($scope.dynamicGridSuffix) {
      toSave.gridId = [toSave.gridId, $scope.dynamicGridSuffix].join(':');
    }
    return toSave;
  }
  function emitSortChange(criteria) {
    $scope.$emit('grid:sortApplied', criteria || $scope.gridSettings.sortCriteria);
  }
  function registerFillDownHandler() {
    $scope.asyncGridApply('handlekeyboardnavigation', $scope.keyboardNavigationHandler);
  }
  function applyGridSorting(sortCriteria) {
    if ($scope.isServerSortingEnabled) {
      dataRetrieverService.gridSortApplied(sortCriteria, $scope.screen, $scope.mode);
    }
  }
  function assignDefaultCriteria() {
    applyGridSorting($scope.gridSettings.sortCriteria || $scope.getDefaultSortCriteria());
    JQXGridCustomSortService.setDefaultSortCriteria($scope.gridId, $scope.getDefaultSortCriteria());
  }
  function getGridData() {
    if ($scope.retrieveDataOnInit) {
      retrieveData();
    }
  }
  function initializeGrid() {
    registerFillDownHandler();
    if ($scope.withoutUserSettings) {
      assignDefaultCriteria();
      getGridData();
    } else if ($scope.dynamicGridSuffix) {
      GridSettingsService.retrieveGridSettings($scope.gridId, $scope.dynamicGridSuffix).then(_.partialRight(updateGridSettings, $scope.dynamicGridSuffix, $scope.dynamicGridSettings))["catch"](assignDefaultCriteria)["finally"](getGridData);
    } else {
      GridSettingsService.retrieveGridSettings($scope.gridId, $scope.dynamicColumnsView).then(updateGridSettings)["catch"](assignDefaultCriteria)["finally"](getGridData);
    }
  }
  $scope.clearFilters = function () {
    $scope.asyncGridApply('clearfilters');
  };
  function applyLastGridState() {
    if ($scope.keepGridFilteringState && $scope.gridLastState) {
      $scope.jqxGridSettings.jqxGrid('loadstate', $scope.gridLastState);
    }
  }
  function storeLastGridState() {
    if ($scope.keepGridFilteringState) {
      // with new click-anywhere selection mode we should reset selected row indexes
      $scope.gridLastState = _.assign($scope.jqxGridSettings.jqxGrid('getstate'), {
        selectedrowindex: -1,
        selectedrowindexes: []
      });
    }
  }
  function logDataSize(data) {
    if (data && data.length) {
      $log.metric($scope.gridId + '-rows', data.length, 'grid-rows-count');
    }
    return data;
  }
  function invokeBeforeShowDataHandler(data) {
    if ($scope.beforeShowData && typeof $scope.beforeShowData === 'function') {
      return $scope.beforeShowData.call(undefined, data);
    }
    return data;
  }
  function updateLastRefreshedTimestamp() {
    $scope.lastRefreshed = momentService.now(momentService.FIELD.EVENT_TIME_STAMP);
  }
  function retrieveComponentData() {
    if (_.isUndefined($scope.localData)) {
      return dataRetrieverService.getDataRetriever(dataRetrieverConstantsService[$scope.screen], $scope.mode, $scope.target).retrieveComponentData($scope.gridId);
    } else {
      if (_.isFunction($scope.localData)) {
        return $scope.localData();
      }
      return $q.when($scope.localData);
    }
  }
  function retrieveData() {
    $scope.undoVisible.show = false;
    return BenchmarkService.benchmarkPromise('retrieve-data-' + $scope.gridId, retrieveComponentData).then(invokeBeforeShowDataHandler).then(logDataSize).then(updateData).then(updateLastRefreshedTimestamp)["catch"](function () {
      $scope.gridDataLoaded = true;
      $scope.isManualRefreshInProgress = false;
    });
  }
  function notEmptyArray(array) {
    return _.isArray(array) && !_.isEmpty(array);
  }
  function getRowIndexesForFilter(filter) {
    var keyColumns = ConfigurationLoaderService.getGridKeyColumns($scope.gridId) ? ConfigurationLoaderService.getGridKeyColumns($scope.gridId).keyColumns : [];
    var newFilter = notEmptyArray(keyColumns) ? _.pick(filter, keyColumns) : filter;
    var matcher = _.matches(notEmptyArray(newFilter) ? newFilter : filter);
    var result = [];
    var localData = _.get($scope.jqxGridSettings, ['source', '_source', 'localdata']);
    if (localData !== undefined) {
      for (var i = 0; i < localData.length; i++) {
        if (matcher(localData[i])) {
          result.push(i);
        }
      }
    }
    return result;
  }
  function restoreScrollPositionBeforeRefresh() {
    syncGridCall('scrolloffset', $scope.scrollPositionBeforeRefresh.top, $scope.scrollPositionBeforeRefresh.left);
    $scope.scrollPositionBeforeRefresh = null;
  }
  $scope.restoreScrollPosition = function (scrollPosition) {
    if (scrollPosition) {
      syncGridCall('scrolloffset', scrollPosition.top !== undefined ? scrollPosition.top : 0, scrollPosition.left !== undefined ? scrollPosition.left : 0);
    }
  };

  /**
   * Finds index of the row in displayed rows (filtered and sorted) to scroll to it later using 'ensurerowvisible'
   *
   * @param {Number} rowIndexInLocalData - row index in source._source.localdata
   * @returns {Number} row number among visible rows
   */
  function getRowIndexAmongDisplayedRows(rowIndexInLocalData) {
    return _.findIndex(syncGridCall('getdisplayrows'), {
      uid: rowIndexInLocalData
    });
  }
  function scrollToRow(rowIndexInLocalData) {
    var firstSelectedRowIndex = getRowIndexAmongDisplayedRows(rowIndexInLocalData);
    if (firstSelectedRowIndex > -1) {
      syncGridCall('ensurerowvisible', firstSelectedRowIndex);
      var scrollPos = syncGridCall('scrollposition');
      $scope.restoreScrollPosition(scrollPos);
    }
  }
  $scope.selectRow = function (filter) {
    var indexes = getRowIndexesForFilter(filter);
    indexes.forEach(function (index) {
      syncGridCall('selectrow', index);
    });
    if ($scope.scrollPositionBeforeRefresh) {
      restoreScrollPositionBeforeRefresh();
    } else if (indexes.length > 0) {
      scrollToRow(indexes[0]);
    }
  };
  $scope.applyDefaultSelection = function () {
    var selectedRowIds = syncGridCall('getselectedrowindexes');
    var displayedRows = syncGridCall('getdisplayrows');
    if (displayedRows.length > 0 && selectedRowIds.length === 0) {
      syncGridCall('selectrow', 0);
    }
  };
  $scope.unSelectRow = function (filter) {
    // Take off uid from filter since this indexes changed on sorting.
    var keyColumns = ConfigurationLoaderService.getGridKeyColumns($scope.gridId).keyColumns;
    filter = _.pick(filter, keyColumns);
    var index = _.findIndex($scope.jqxGridSettings.source._source.localdata, filter);
    if (index !== -1) {
      $scope.asyncGridApply('unselectrow', index);
    }
  };
  $scope.unselectFilteredOutRows = function () {
    var selectedRowIds = syncGridCall('getselectedrowindexes');
    var displayedRows = syncGridCall('getdisplayrows');
    _.each(selectedRowIds, function (index) {
      if (!_.find(displayedRows, ['uid', index])) {
        $scope.asyncGridApply('unselectrow', index);
      }
    });
  };
  $scope.clearSelection = function () {
    return $scope.asyncGridApply('clearselection');
  };
  $scope.applyCustomizationChanges = function (data) {
    $scope.$emit('grid:gridCustomizationChanged', $scope.gridId);
    var saveSortCriteria = typeof data.sort !== 'undefined',
      columnsUpdated = typeof data.columns !== 'undefined';
    $scope.asyncGridApply().then(function () {
      $scope.gridSettings.columns = data.columns || $scope.gridSettings.columns;
      $scope.gridSettings.sortCriteria = data.sort || $scope.gridSettings.sortCriteria;
      if (saveSortCriteria) {
        $scope.gridSettings.defaultSortCriteria = data.sort.clone();
      }
      $q.when($scope.dynamicColumnsView === 'default' ? syncJQXGridSettings() : addDynamicConfigColumns($scope.dynamicColumnsView)).then(function () {
        if (columnsUpdated && _.isObject($scope.jqxGridSettings.source)) {
          updateData($scope.jqxGridSettings.source.loadedData);
        }
        GridSettingsService.postGridColumns(prepareForSaving($scope.gridSettings, saveSortCriteria));
        if (columnsUpdated) {
          $scope.$broadcast('grid:gridColumnsUpdated');
        }
      });
    });
  };
  $scope.getDefaultGridSettingsJson = function (gridId) {
    var defaultGridSettings = ConfigurationLoaderService.getGridSettings(gridId, $scope.dynamicColumnsView);
    return JSON.stringify(defaultGridSettings);
  };
  $scope.applyAndSaveGridSettingsJson = function (gridSettingsJson) {
    var gridSettings = GridSettingsService.transformResponse(gridSettingsJson);
    $scope.applyCustomizationChanges(gridSettings);
  };
  $scope.saveGridSettingsJson = function (gridSettingsJson) {
    var gridSettings = GridSettingsService.transformResponse(gridSettingsJson);
    GridSettingsService.postGridColumns(prepareForSaving(gridSettings, true));
  };
  $scope.clearSortingIndicators = function () {
    _.forEach($scope.jqxGridSettings.columns, function (c) {
      c.sortingIndicator = undefined;
    });
  };
  $scope.removeSorting = function () {
    $scope.clearSortingIndicators();
    $scope.asyncGridApply('removesort');
  };
  $scope.removeFiltering = function ($event) {
    if ($scope.filteringDisabled) {
      $event.stopPropagation();
    }
    $scope.clearFilters();
  };
  $scope.updateFilteringState = function (filters) {
    $scope.filteringDisabled = filters && filters.length === 0;
  };
  $scope.printGrid = function () {
    var columnsToHide = columnNameTransformationService.getColumnsToHide($scope.jqxGridSettings);
    columnNameTransformationService.hideColumns($scope.jqxGridSettings, columnsToHide);
    $scope.asyncGridApply('exportdata', 'html').then(function (gridContent) {
      columnNameTransformationService.unhideColumns($scope.jqxGridSettings, columnsToHide);
      gridContent = columnNameTransformationService.flattenColumnNames(gridContent, $scope.jqxGridSettings, 'html');
      printService.print($scope.gridId, gridContent);
    });
  };
  function updateSortingIndicators(sortCriteria) {
    var columnToNumber = _.invert(sortCriteria.getActiveSortColumns().map(function (column) {
      return column.field;
    }));
    var showIndicator = !$scope.isDefaultSort(sortCriteria) && Object.keys(columnToNumber).length > 1;
    _.forEach($scope.jqxGridSettings.columns, function (c) {
      var columnIndex = columnToNumber[c.datafield];
      var columnSorted = columnIndex !== undefined;
      c.sortingIndicator = showIndicator && columnSorted ? Number(columnIndex) + 1 : undefined;
    });
  }
  $scope.sortBy = function (criteria, isCustomSort) {
    criteria.setIsCustomSort(isCustomSort || true);
    $scope.lastSortCriteriaApplied = criteria;
    updateSortingIndicators(criteria);
    $scope.asyncGridApply('sortby', criteria, '');
  };
  $scope.getColumnNameBy = function (index) {
    return $scope.jqxGridSettings.columns[index].datafield;
  };
  $scope.fireGridSorted = function (latestSortCriteria) {
    syncGridCall('clearselection');
    $scope.lastSortCriteriaApplied = latestSortCriteria;
    emitSortChange(latestSortCriteria);
    $rootScope.$broadcast('grid:sorted', latestSortCriteria);

    //saving current sorting in dataRetrieverService
    applyGridSorting(latestSortCriteria || $scope.gridSettings.sortCriteria);
    selectRows($scope.selectionFilters);
  };
  $scope.setShowSortMenuItems = function (showSortMenuItems) {
    $scope.asyncGridApply('showsortmenuitems', showSortMenuItems);
  };
  $scope.setShowSortColumnBackground = function (showSortColumnBackground) {
    $scope.asyncGridApply('showsortcolumnbackground', showSortColumnBackground && $scope.jqxGridSettings.showsortcolumnbackground);
  };
  $scope.getDefaultSortCriteria = function () {
    return $scope.gridSettings.defaultSortCriteria.clone();
  };
  $scope.isDefaultSort = function (sortCriteria) {
    return $scope.gridSettings.defaultSortCriteria.hashCode() === sortCriteria.hashCode();
  };
  function indexToRow(index) {
    return $scope.jqxGridSettings.source.loadedData[index];
  }
  $scope.getSelectedRows = function () {
    var selectedIndexes = syncGridCall('selectedrowindexes') || [];
    return selectedIndexes.map(indexToRow);
  };
  $scope.getDisplayRows = function () {
    return syncGridCall('getdisplayrows');
  };
  $scope.getDisplayRowFilters = function () {
    return getSelectionFilters($scope.getDisplayRows());
  };
  $scope.fireGridDataUpdated = function () {
    $scope.gridDataUpdated = true;
  };
  $scope.resetGridDataUpdated = function () {
    $scope.gridDataUpdated = false;
  };
  function onlyExistingElementIndex(elementIndex) {
    return elementIndex > -1;
  }
  $scope.rowSelectionChanged = function () {
    if ($scope.skipRowSelectionEvent) {
      return;
    }
    $scope.asyncGridApply('selectedrowindexes').then(function (selectedRowIndexes) {
      selectedRowIndexes = selectedRowIndexes || [];
      var selectedRows = selectedRowIndexes.map(indexToRow);
      var newSelectionFilters = getSelectionFilters(selectedRows);
      if (!_.isEqual($scope.selectionFilters, newSelectionFilters)) {
        var displayRows = $scope.getDisplayRows();
        var displayRowIndexes = _.map(selectedRowIndexes, function (rowIndexInLocalData) {
          return _.findIndex(displayRows, {
            uid: rowIndexInLocalData
          });
        }).filter(onlyExistingElementIndex);
        displayRowIndexes = _.sortBy(displayRowIndexes);
        var allRowFilters = getSelectionFilters(displayRows);
        var displayRowFilters = displayRowIndexes.map(function (index) {
          return allRowFilters[index];
        });
        var visibleRowProperties = {
          displayRows: displayRows,
          displayRowIndexes: displayRowIndexes,
          displayRowFilters: displayRowFilters,
          allRowFilters: allRowFilters
        };
        $scope.selectionFilters = newSelectionFilters;
        var allRows = $scope.jqxGridSettings.source && $scope.jqxGridSettings.source.loadedData;
        $scope.$emit('grid:rowSelectionChanged', selectedRows, $scope.gridId, allRows, selectedRowIndexes, $scope.selectionFilters, visibleRowProperties);
        $scope.$broadcast('grid:rowSelectionChanged', selectedRows, $scope.gridId, allRows, selectedRowIndexes, $scope.selectionFilters, visibleRowProperties);
      }
    });
  };
  $scope.onGridCellDoubleClick = function (event) {
    $scope.$broadcast('grid:celldoubleclick', event.args, $scope.gridId);
  };
  $scope.onGridCellClick = function (event) {
    var rowData = $scope.jqxGridSettings.source.loadedData[event.args.rowindex];
    $rootScope.$broadcast('grid:cellclick', event, rowData, $scope.gridId);
  };
  $scope.setGridVisibilityState = function (visible) {
    if (visible) {
      $scope.gridVisiblePromise.resolve();
    }
  };

  /**
   * Check cell validity
   * @param event
   */
  function isCellValid(event) {
    var args = event.args;
    var owner = args.owner;
    if (!owner) {
      return true;
    }
    var cell = owner.getcell(args.rowindex, args.datafield);
    var column = owner.getcolumn(args.datafield);
    if (_.isNull(column.validation)) {
      return true;
    }
    return column.validation(cell, args.value) === true;
  }
  $scope.cellEndEditHandler = function (event) {
    var args = event.args;
    if (args.rowindex === undefined) {
      return;
    }
    if (!isCellValid(event)) {
      return false;
    }
    markCellAsEdited(args.rowindex, args.datafield, args.oldvalue, args.value);
    initCellEndEditData(args.rowindex, args.datafield, args.value);
    updateDataRowAfterCellEndEdit($scope.jqxGridSettings.source.loadedData);
  };
  function calculateChangedValue(columnDataField, value, valueFormatted) {
    var dataField = getFieldSettings(columnDataField);
    var numericTypes = ['number', 'percentage'];
    if (dataField && numericTypes.indexOf(dataField.type) !== -1) {
      if (value === '' || value === null) {
        return null;
      } else if (dataField.percentageFormat && !valueFormatted) {
        return parseFloat(value) / 100;
      } else {
        return parseFloat(value);
      }
    } else {
      return value;
    }
  }
  function getFieldSettings(columnDataField) {
    return $scope.dynamicGridSettings ? _.find($scope.dynamicGridSettings.dynamicFields, {
      'name': columnDataField
    }) : ConfigurationLoaderService.getFieldSettings($scope.gridId, columnDataField);
  }
  function initCellEndEditData(rowIds, columnDataField, value, valueFormatted) {
    var rows = Array.isArray(rowIds) ? rowIds : [rowIds];
    _.forEach(rows, function (rowId) {
      $scope.cellEndEditData.push({
        rowId: rowId,
        columnDataField: columnDataField,
        changedValue: calculateChangedValue(columnDataField, value, valueFormatted)
      });
    });
  }
  var invalidateData = _.debounce(retrieveData, 50);
  var invalidateDataAndSelectRowsSync = _.debounce(function (selectedRowsData) {
    $q.when(retrieveData()).then(function () {
      if (selectedRowsData !== undefined) {
        $timeout(function () {
          syncGridCall('clearselection');
          selectRows(selectedRowsData);
          if ($scope.scrollPositionBeforeRefresh && (selectedRowsData === undefined || selectedRowsData.length === 0)) {
            restoreScrollPositionBeforeRefresh();
          }
        }, 0);
      }
    });
  }, 50);
  $scope.$on('brush-filter:filterApplied', function () {
    invalidateData();
  });
  function onSearchEvent() {
    if ($scope.isLiveData) {
      liveDataService.unsubscribe($scope.gridId);
    }
    if ($scope.retrieveDataOnSearch) {
      invalidateData();
    }
  }
  function isGridExcluded(excludeGrids) {
    return _.isArray(excludeGrids) && excludeGrids.indexOf($scope.gridId) === -1;
  }
  $scope.$on('search-criteria:searchChangeEvent', onSearchEvent);

  //TODO replace usages across application to handler 'grid:clearAndLoadData:' + $scope.gridId below
  $scope.$on('grid:dataChanged', function (event, excludeGrids) {
    if (!excludeGrids || isGridExcluded(excludeGrids)) {
      $scope.refreshGrid();
    }
  });
  $scope.$on('grid:setDeferredClear:' + $scope.gridId, function () {
    deferredLoadOnVisible = true;
  });
  $scope.$on('grid:checkDeferredClear:' + $scope.gridId, function () {
    if (deferredLoadOnVisible) {
      deferredLoadOnVisible = false;
      $scope.refreshGrid();
    }
  });
  $scope.$on('last-review:update-grid', function (event, actionType, flightIds) {
    var allRows = $scope.jqxGridSettings.source && $scope.jqxGridSettings.source.loadedData;
    var cellsToUpdate = userActionService.prepareReviewCellsToUpdate(actionType, flightIds, allRows);
    if (cellsToUpdate.length > 0) {
      updateCells({
        gridId: $scope.gridId,
        cells: cellsToUpdate
      });
    }
  });
  function isCellValueChanged(newValue, oldValue) {
    return !(_.isNil(newValue) && _.isNil(oldValue));
  }
  function hasRowChangedValues(dataRow) {
    return !!_.findKey(dataRow._old, function (oldValue, propertyName) {
      return isCellValueChanged(dataRow[propertyName], oldValue);
    });
  }
  $scope.hasUnsavedAdjustments = function () {
    var loadedData = _.get($scope, 'jqxGridSettings.source.loadedData');
    return loadedData && _.chain(loadedData).filter('_old').find(hasRowChangedValues).value();
  };
  function startManualRefresh() {
    $scope.scrollPositionBeforeRefresh = syncGridCall('scrollposition');
    $rootScope.$broadcast('grid:manual-refresh:' + $scope.gridId);
    $scope.isManualRefreshInProgress = true;
    $scope.refreshGrid();
  }
  $scope.refreshGridButtonHandler = function () {
    if (($scope.isLiveData || $scope.confirmAdjustmentsClearOnRefresh) && $scope.hasUnsavedAdjustments()) {
      $rootScope.$broadcast('refresh-modal:openModal', $scope.gridId);
    } else {
      startManualRefresh();
    }
  };

  /**
   * Returns array of key columns values for each row, which will be used as filters to select rows
   * Filters each row columns and selects only key columns
   * @param {Array} selectedRows - array of rows' columns' values
   * @returns {Array}
   */
  function getSelectionFilters(selectedRows) {
    selectedRows = selectedRows || $scope.getSelectedRows();
    var selectionFilters = [];
    if (notEmptyArray(selectedRows)) {
      var keyColumnsSettings = ConfigurationLoaderService.getGridKeyColumns($scope.gridId);
      if (keyColumnsSettings && notEmptyArray(keyColumnsSettings.keyColumns)) {
        _.forEach(selectedRows, function (row) {
          var selectionFilter = _.pick(row, keyColumnsSettings.keyColumns);
          selectionFilter = _.isEmpty(selectionFilter) ? row : selectionFilter;
          selectionFilters.push(selectionFilter);
        });
      } else {
        selectionFilters = selectedRows;
      }
    }
    return selectionFilters;
  }
  function clearCacheAndReload(selectionFilters) {
    dataService.clearCache();
    invalidateDataAndSelectRowsSync(selectionFilters);
  }
  $scope.clearCache = function () {
    dataService.clearCache();
  };
  $scope.refreshGrid = function () {
    $scope.scrollPositionBeforeRefresh = syncGridCall('scrollposition');
    clearCacheAndReload(getSelectionFilters());
  };
  $scope.$on('grid:clearAndLoadData:' + $scope.gridId, $scope.refreshGrid);
  $scope.$on('grid:startManualRefresh:' + $scope.gridId, startManualRefresh);
  $scope.$on('grid:reinitialize:' + $scope.gridId, function () {
    initializeGrid();
  });
  $scope.$on('grid:loadData:' + $scope.gridId, function (event, selectionFilters) {
    invalidateDataAndSelectRowsSync(selectionFilters);
  });
  $scope.$on('grid:dataAndSelectionChangedGrid:' + $scope.gridId, function (event, selectedRowsData) {
    clearCacheAndReload(selectedRowsData);
  });
  $scope.$on('grid:unSelectRows', function (event, filters) {
    _.forEach(filters, function (filter) {
      $scope.unSelectRow(filter);
    });
  });
  $scope.$on('grid:clearSelection', $scope.clearSelection);

  /**
   * Selects rows
   * @param {Array} selectedRowsData - can be array of rows (with all columns) or already prepared selection filters (arrays of only key columns)
   */
  function selectRows(selectedRowsData) {
    if (selectedRowsData) {
      var selectionFilters = getSelectionFilters(selectedRowsData);
      _.forEach(selectionFilters, $scope.selectRow);
    }
  }
  $scope.clearAndSelectRows = function (selectedRowsData, emitAfterSelecting) {
    $scope.clearSelection().then(function () {
      selectRows(selectedRowsData);
      if (emitAfterSelecting) {
        $scope.$emit('grid:clearAndSelect:finished');
      }
    });
  };
  $scope.$on('grid:applyDefaultSelection:' + $scope.gridId, function () {
    $timeout(function () {
      $scope.applyDefaultSelection();
    }, 0);
  });
  $scope.$on('grid:clearAndSelect:' + $scope.gridId, function (event, selectedRowsData) {
    $scope.clearAndSelectRows(selectedRowsData);
  });
  $scope.$on('grid:setCellValue', function (event, params) {
    var gridId = params.gridId || $scope.gridId;
    if (params && $scope.gridId === gridId) {
      $scope.asyncGridApply('setcellvaluebyid', params.rowId, params.columnName, params.newValue);
      $scope.clearSelection();
      markCellAsEdited(params.rowId, params.columnName, params.oldValue);
      $scope.jqxGridSettings.source.loadedData[params.rowId][params.columnName] = params.newValue;
      if (!params.refreshOnly) {
        $scope.updateData($scope.jqxGridSettings.source.loadedData);
      } else {
        $scope.asyncGridApply('refresh');
      }
    }
  });
  function updateCells(params) {
    if (params && params.cells && params.cells.length > 0 && $scope.gridId === params.gridId) {
      var scrollPos = syncGridCall('scrollposition');
      params.cells.forEach(function (cell) {
        $scope.jqxGridSettings.source.loadedData[cell.rowId][cell.columnName] = cell.newValue;
      });
      $scope.jqxGridSettings.jqxGrid('updatebounddata', 'cells');
      $scope.restoreScrollPosition(scrollPos);
    }
  }
  $scope.$on('grid:refresh:' + $scope.gridId, function () {
    $scope.updateGridSize();
  });
  $scope.updateGridSize = function () {
    var scrollPos = syncGridCall('scrollposition');
    $scope.jqxGridSettings.jqxGrid('_updatesize', true, true);

    /* in _updatesize jqxgrid function timeout is 5 and we want to execute this after */
    $timeout(function () {
      $scope.restoreScrollPosition(scrollPos);
    }, 10);
  };
  $scope.clearExpandedRowDetails = function () {
    if ($scope.rowDetails) {
      _.forEach(getExpandedRowDetailsIndexes(), function (index) {
        $scope.jqxGridSettings.jqxGrid('hiderowdetails', index);
      });
    }
  };
  function getExpandedRowDetailsIndexes() {
    return _.chain($scope.jqxGridSettings.jqxGrid.apply($scope.jqxGridSettings, ['detailsVisibility'])).map(function (data, index) {
      return data === false ? index : undefined;
    }).without(undefined).value();
  }
  function findLoadedDataRow(rowId) {
    var row = $scope.jqxGridSettings.source.loadedData[rowId];
    if (row && row.originalRowId === rowId) {
      return row;
    } else {
      return _.find($scope.jqxGridSettings.source.loadedData, ['originalRowId', rowId]);
    }
  }
  function updateCustomClasses(cellVal) {
    var row = $scope.jqxGridSettings.source.loadedData[cellVal.rowId];
    row[cellVal.columnName] = cellVal.value;
    var customClasses = _.isNil(row.customClasses) ? {} : row.customClasses;
    _.set(row, 'customClasses', customClasses);
    _.set(row.customClasses, cellVal.columnName, cellVal.customClasses);
  }
  function updateLoadedData(cellVal) {
    var row = findLoadedDataRow(cellVal.rowId);
    if (row && cellVal.columnName) {
      row[cellVal.columnName] = cellVal.value;
    }
  }
  $scope.$on('grid:setMultipleCellsValue', function (event, gridId, cellValues, noReload) {
    gridId = gridId || $scope.gridId;
    if ($scope.gridId === gridId) {
      _.forEach(cellValues, function (cellVal) {
        $scope.asyncGridApply('setcellvaluebyid', cellVal.rowId, cellVal.columnName, cellVal.value);
        updateLoadedData(cellVal);
        if (cellVal.oldValue !== undefined) {
          markCellAsEdited(cellVal.rowId, cellVal.columnName, cellVal.oldValue);
        }
        if (_.has(cellVal, 'customClasses')) {
          updateCustomClasses(cellVal);
        }
      });
      $scope.clearSelection();
      if (noReload) {
        $scope.asyncGridApply('refresh');
      } else {
        $scope.updateData($scope.jqxGridSettings.source.loadedData);
      }
    }
  });
  $scope.$on('grid:undo', function (event, gridId) {
    if ($scope.gridId === gridId) {
      $scope.undo();
    }
  });
  $scope.$on('jqxGridCreated', function (event) {
    event.stopPropagation();
    $scope.gridReadyPromise.resolve();
  });
  function checkForNotifications(data) {
    if ($scope.isLiveData) {
      liveDataService.subscribe($scope.gridId, data);
    }
  }
  $scope.cellValueChanged = function (event) {
    $scope.undoVisible.show = true;
    $rootScope.$broadcast('grid:cellValueChanged', event.args, $scope.gridId);
  };
  $scope.rowExpandHandler = function (event) {
    if (!!$scope.rowDetailsExpandMultipleRows) {
      return;
    }
    var rows = $scope.jqxGridSettings.jqxGrid('getrows');
    rows.forEach(function (data, index) {
      if (event.args.rowindex !== index) {
        $scope.jqxGridSettings.jqxGrid('hiderowdetails', index);
      }
    });
  };
  $scope.undo = function () {
    $scope.refreshGrid();
    $rootScope.$broadcast('clearChangedValue');
    $rootScope.$broadcast('grid:data-pristine');
  };
  $scope.updateData = updateData;
  $scope.getGridDisplayRows = function () {
    return syncGridCall('getdisplayrows');
  };
  this.getLastSortCriteriaApplied = function () {
    return $scope.lastSortCriteriaApplied;
  };
  $scope.$on($scope.screen + ':scenariosChanged', function () {
    $scope.undoVisible.show = false;
    invalidateData();
  });
  $scope.$on('scenarios:saved', function (e, overridesGridId) {
    if ($scope.gridId === overridesGridId) {
      $scope.undoVisible.show = false;
    }
  });
  $scope.$on($scope.screen + ':flowTypeChanged', invalidateData);
  $scope.$on('$destroy', function () {
    if ($scope.isLiveData) {
      liveDataService.unsubscribe($scope.gridId);
    }
  });
  initializeGrid();
  $scope.$on('grid:removeFilter:' + $scope.gridId, function () {
    if (!$scope.filteringDisabled) {
      $scope.clearFilters();
    }
  });
  $scope.$on('grid:removeSorting:' + $scope.gridId, function () {
    if ($scope.isServerSortingEnabled) {
      $scope.removeSorting();
    }
  });
  $scope.$on('grid:getRowsByKeyColumns', function (event, gridId, overrides, callbackData) {
    if (gridId !== $scope.gridId) {
      return;
    }
    var selectionFilters = getSelectionFilters(overrides);
    var rowIndices = _.chain(selectionFilters).reduce(function (indices, filter) {
      return indices.concat(getRowIndexesForFilter(filter));
    }, []).uniq().map(function (index) {
      return {
        rowId: index,
        rowData: $scope.jqxGridSettings.source.loadedData[index]
      };
    }).value();
    $rootScope.$broadcast('grid:retrievedRowsByKeyColumns:' + gridId, rowIndices, callbackData);
  });
};
GridPanelController.$inject = ['$scope', '$rootScope', '$log', '$q', '$timeout', 'GridSettingsService', 'PrintService', 'JQXGridSettingsFactory', 'GridSettingsMergeService', 'ConfigurationLoaderService', 'SortCriteriaFactory', 'JQXGridDataAdapterFactory', 'JQXGridCustomSortService', 'JQXGridCellTreatmentService', 'CalculatedColumnService', 'DataRetrieverService', 'DataRetrieverConstantsService', 'DataService', 'GridColumnFactory', 'BenchmarkService', 'MomentService', 'GridTooltipService', 'UserPreferencesService', 'ColumnNameTransformationService', 'GridColumnConditionallyEditableService', 'LiveDataService', 'UserActionService', 'GridDynamicConfigDrivenColumnStrategiesService'];
module.exports = GridPanelController;